import { Outlet } from 'react-router-dom'
import {
    Box,
    Stack,
    Paper,
    useTheme,
    useMediaQuery
} from '@mui/material'
import Logo from '@assets/logo.png'

export default function Authentication() {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <>
            <Box sx={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                gap: 3
            }}>
                {isMobile && <img src={Logo} width='150'/>}
                <Paper
                    sx={{
                        overflow: 'hidden',
                        width: '90%',
                        maxWidth: '750px',
                        borderRadius: 3
                    }}
                    variant='outlined'
                >
                    <Box sx={{display: 'flex', p: 3}}>
                        <Stack sx={{width: isMobile ? '100%' : '50%'}}>
                            <Outlet />
                        </Stack>
                        {!isMobile &&
                            <Box
                                sx={{
                                    width:'50%',
                                    display:'flex',
                                    justifyContent:'center',
                                    alignItems:'center'
                                }}
                            >
                                <img src={Logo} width='50%'/>
                            </Box>
                        }
                    </Box>
                </Paper>
            </Box>
        </>
    )
}
